export default {"src":"/_next/static/media/pencil_regular.390c2285.svg","height":24,"width":24};